export default "__VITE_ASSET__WCP1FqzQ__"